// src/components/blog/content/InteractiveWrapper.tsx

'use client'

import { type ReactNode } from 'react'
import { motion } from 'motion/react'

interface InteractiveWrapperProps {
  children: ReactNode
  className?: string
}

export function InteractiveWrapper({ children, className }: InteractiveWrapperProps): JSX.Element {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className={className}
    >
      {children}
    </motion.div>
  )
} 